import React from 'react';
import PropTypes from 'prop-types';
import styles from './AuthError.module.css';

export default function AuthErrorPage({ errorMessage, onTryAgain }) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconWrapper}>
            <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <h1 className={styles.title}>Acesso Não Autorizado</h1>
        </div>

        <div className={styles.content}>
          <p className={styles.message}>
            {errorMessage || 'O token de autenticação é inválido ou expirou. Por favor, tente novamente ou entre em contato com o suporte.'}
          </p>
          <button onClick={onTryAgain} className={styles.button}>
            <span className={styles.buttonIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="1 4 1 10 7 10"></polyline>
                <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
              </svg>
            </span>{' '}
            Tentar Novamente
          </button>

          <div className={styles.footer}>
            <p>Se o problema persistir, entre em contato com o suporte.</p>
          </div>
        </div> 
        </div>
    </div>
  );
}

AuthErrorPage.propTypes = {
  errorMessage: PropTypes.string,
  onTryAgain: PropTypes.func.isRequired
};